import { Component, Inject, Input } from '@angular/core';

import { consts } from '@src/constants/consts';

@Component({
    selector: 'menu-item',
    template: require('./menu-item.component.html')
})
export class MenuItemComponent {
    @Input() public index: any;
    @Input() public name: any;
    @Input() public item: any;
    @Input() public expand: any;
    @Input() public customClass: any;

    public show = false;
    public activeMenu = consts.activeMenuClass;

    constructor(@Inject('$state') private $state: any) {
    }

    public navigate(event: any, item: any) {
        if (!item.appLink) {
            return;
        }
        event.preventDefault();
        this.$state.go(item.appLink, item.name);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/menu-item/menu-item.component.ts